/**
 * A custom error class that signals to our error utilities (such as
 * `getErrorMessage.ts`) that it's OK to display the error's `message`
 * directly to users, i.e. it's not computer/code-specific jargon.
 */
export default class UserFacingError extends Error {}
